// extracted by mini-css-extract-plugin
export default {"loader":"styles-module__loader__src-labstep-web-core-Loader-TimeEnabled-_LiFbx"};